export default "__VITE_ASSET__541b806a__"